function pgTrybeCheckoutUrl(destination, search) {
  try {
    const code = new URLSearchParams(search).get('trybe');
    if (!code || code.length > 2048 || /[\u0000-\u001f\u007f]/.test(code)) return destination;
    const url = new URL(destination);
    if (url.protocol !== 'https:' || url.hostname !== 'pilatesflo.com' || url.port || url.username || url.password) return destination;
    if (!/^\/(?:cart(?:\/|$)|checkouts(?:\/|$))/.test(url.pathname) || url.searchParams.has('trybe')) return destination;
    url.searchParams.set('trybe', code);
    return url.href;
  } catch (_) {
    return destination;
  }
}

(function (window, document) {
  "use strict";

  var EVENT_TYPES = [
    "quiz_start", "screen_view", "answer", "back", "result_view",
    "cta_click", "offer_interaction", "quiz_complete", "quiz_error"
  ];
  var ATTR_KEYS = [
    "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term",
    "fbclid", "ttclid", "gclid"
  ];
  var MAX_QUEUE = 1000;
  var MAX_ATTEMPTS = 5;
  var RETRY_COOLDOWN_MS = 60 * 1000;
  var QUEUE_TTL_MS = 24 * 60 * 60 * 1000;
  var FLUSH_MS = 2000;
  var sdkScript = document.currentScript;
  var sdkOrigin = null;
  try { sdkOrigin = sdkScript && new URL(sdkScript.src).origin; } catch (_) {}

  var state = {
    config: null,
    endpoint: null,
    sessionId: null,
    sessionToken: null,
    sessionExpiresAt: null,
    sequence: 0,
    queue: [],
    flushing: false,
    initPromise: null,
    initAttempts: 0,
    clientSessionKey: null,
    createdAt: null,
    retryAt: 0,
    failures: 0,
    blocked: null,
    dropped: 0,
    legacyPending: 0,
    lastSuccessAt: null,
    ownershipReady: true,
    ownershipPromise: null,
    releaseOwnership: null,
    ownershipWarning: null,
    storageWarning: null,
    deliveryFailures: 0,
    diagnosticSignature: null,
    onceEvents: {},
    timer: null
    ,assignments: []
    ,answers: {}
    ,reconcilers: []
  };

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    var bytes = new Uint8Array(16);
    if (window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(bytes);
    else for (var i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    var hex = Array.prototype.map.call(bytes, function (b) { return b.toString(16).padStart(2, "0"); }).join("");
    return hex.slice(0, 8) + "-" + hex.slice(8, 12) + "-" + hex.slice(12, 16) + "-" + hex.slice(16, 20) + "-" + hex.slice(20);
  }

  function storageGet(storage, key) {
    try { return storage.getItem(key); } catch (_) { state.storageWarning = "browser_storage_unavailable"; return null; }
  }

  function browserStorage(name) {
    try { return window[name]; } catch (_) { state.storageWarning = "browser_storage_unavailable"; return null; }
  }

  function storageSet(storage, key, value) {
    try { storage.setItem(key, value); } catch (_) { state.storageWarning = "browser_storage_unavailable"; }
  }

  function storageRemove(storage, key) {
    try { storage.removeItem(key); } catch (_) {}
  }

  function trafficSuffix() { return state.config.isTest ? "_qa" : ""; }
  function queueKey() { return "nyquiz_queue_v2_" + state.config.quizKey + "_" + state.config.versionKey + trafficSuffix(); }
  function sessionKey() { return "nyquiz_session_" + state.config.quizKey + "_" + state.config.versionKey + trafficSuffix(); }

  function getHealth() {
    return {
      status: state.blocked ? "blocked" : state.failures || state.dropped || state.legacyPending || state.ownershipWarning || state.storageWarning ? "degraded" : "collecting",
      reason: state.blocked,
      ownershipWarning: state.ownershipWarning,
      storageWarning: state.storageWarning,
      pending: state.queue.length,
      dropped: state.dropped,
      legacyPending: state.legacyPending,
      failures: state.failures,
      retryAt: state.retryAt || null,
      lastSuccessAt: state.lastSuccessAt,
      sessionId: state.sessionId
    };
  }

  function publishHealth() {
    try { window.dispatchEvent(new CustomEvent("nyquiz:health", { detail: getHealth() })); } catch (_) {}
  }

  function loadQueue() {
    // The old localStorage queue has no session ownership. Never replay it into
    // a new visit. Leave it untouched and expose the unresolved legacy count.
    var legacy = storageGet(browserStorage("localStorage"), "nyquiz_queue_" + state.config.quizKey + "_" + state.config.versionKey);
    try { state.legacyPending = legacy ? JSON.parse(legacy).length : 0; } catch (_) {}
    var raw = storageGet(browserStorage("sessionStorage"), queueKey());
    if (!raw) return [];
    try {
      var now = Date.now();
      var saved = JSON.parse(raw);
      if (saved.owner !== state.clientSessionKey || !Array.isArray(saved.entries)) {
        state.blocked = "queue_owner_mismatch";
        return [];
      }
      state.dropped = Number(saved.dropped || 0);
      state.deliveryFailures = Number(saved.deliveryFailures || 0);
      state.diagnosticSignature = saved.diagnosticSignature || null;
      var current = saved.entries.filter(function (entry) {
        var valid = entry && entry.event && now - Number(entry.queuedAt || 0) <= QUEUE_TTL_MS;
        if (!valid) state.dropped += 1;
        return valid;
      });
      if (current.length > MAX_QUEUE) state.dropped += current.length - MAX_QUEUE;
      return current.slice(0, MAX_QUEUE);
    } catch (_) { return []; }
  }

  function saveQueue() {
    storageSet(browserStorage("sessionStorage"), queueKey(), JSON.stringify({
      owner: state.clientSessionKey, sessionId: state.sessionId,
      entries: state.queue, dropped: state.dropped,
      deliveryFailures: state.deliveryFailures, diagnosticSignature: state.diagnosticSignature
    }));
    publishHealth();
  }

  function visitorId() {
    var key = "nyquiz_visitor_id";
    var value = storageGet(browserStorage("localStorage"), key);
    if (!value) {
      value = uuid();
      storageSet(browserStorage("localStorage"), key, value);
    }
    return value;
  }

  // Only report after the collector can communicate. Failures remain durable in
  // the visit queue until recovery; diagnostics never claim a live health check.
  function reportDiagnostics() {
    var detail = {
      code: "collector_delivery_diagnostic",
      recoveredFailures: state.deliveryFailures,
      droppedEvents: state.dropped,
      legacyUnownedEvents: state.legacyPending,
      storageWarning: state.storageWarning,
      ownershipWarning: state.ownershipWarning
    };
    if (!detail.recoveredFailures && !detail.droppedEvents && !detail.legacyUnownedEvents &&
        !detail.storageWarning && !detail.ownershipWarning) return;
    var signature = JSON.stringify([detail.droppedEvents, detail.legacyUnownedEvents,
      detail.storageWarning, detail.ownershipWarning]);
    if (!detail.recoveredFailures && signature === state.diagnosticSignature) return;
    if (state.queue.length >= MAX_QUEUE) return;
    state.deliveryFailures = 0;
    state.diagnosticSignature = signature;
    track("quiz_error", { properties: detail });
  }

  function attribution() {
    var out = {};
    var configured = state.config && state.config.attribution;
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (_) { params = null; }
    ATTR_KEYS.forEach(function (key) {
      var storageKey = "nyquiz_attr_" + key;
      var incoming = (params && params.get(key)) || (configured && configured[key]);
      if (incoming) storageSet(browserStorage("sessionStorage"), storageKey, incoming);
      out[key] = incoming || storageGet(browserStorage("sessionStorage"), storageKey) || null;
    });
    return out;
  }

  function assignmentToken() {
    if (state.config && state.config.assignmentToken) return state.config.assignmentToken;
    try { return new URLSearchParams(window.location.search).get("nyq_assignment"); }
    catch (_) { return null; }
  }

  function sanitizedLandingUrl() {
    if (state.config && state.config.landingUrl) return state.config.landingUrl;
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete("nyq_assignment");
      return url.toString();
    } catch (_) { return window.location.href; }
  }

  function removeAssignmentTokenFromAddressBar() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has("nyq_assignment")) return;
      url.searchParams.delete("nyq_assignment");
      window.history.replaceState(window.history.state, "", url.toString());
    } catch (_) {}
  }

  function publishAssignments() {
    try {
      window.dispatchEvent(new CustomEvent("nyquiz:assignment", { detail: state.assignments.slice() }));
    } catch (_) {}
    if (state.config && typeof state.config.onAssignment === "function") {
      try { state.config.onAssignment(state.assignments.slice()); } catch (_) {}
    }
  }

  function publishRuntimeConfig() {
    try {
      window.dispatchEvent(new CustomEvent("nyquiz:config", {
        detail: {
          activeVersionKey: state.config.activeVersionKey || state.config.versionKey,
          resultLogic: state.config.resultLogic || null,
          results: Array.isArray(state.config.results) ? state.config.results.slice() : [],
          destinationUrl: state.config.destinationUrl || null
        }
      }));
    } catch (_) {}
  }

  function deviceType() {
    var width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    return width <= 767 ? "mobile" : width <= 1024 ? "tablet" : "desktop";
  }

  function endpoint(path) {
    return state.endpoint.replace(/\/$/, "") + path + "?quizKey=" + encodeURIComponent(state.config.quizKey);
  }

  function post(path, body, keepalive) {
    return window.fetch(endpoint(path), {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: Boolean(keepalive)
    }).then(function (response) {
      if (!response.ok) {
        var error = new Error("Quiz collector returned " + response.status);
        error.status = response.status;
        throw error;
      }
      return response.json();
    });
  }

  function restoreSession() {
    var raw = storageGet(browserStorage("sessionStorage"), sessionKey());
    if (!raw) return false;
    try {
      var saved = JSON.parse(raw);
      if ((saved.createdAt && Date.now() - Number(saved.createdAt) >= QUEUE_TTL_MS) ||
          (!saved.clientSessionKey && saved.expiresAt && Number(saved.expiresAt) <= Date.now())) {
        archiveExpiredVisit(saved.clientSessionKey || saved.sessionId || "legacy");
        return false;
      }
      state.clientSessionKey = saved.clientSessionKey || uuid();
      state.createdAt = Number(saved.createdAt || Date.now());
      state.sessionId = saved.sessionId || null;
      state.sessionToken = Number(saved.expiresAt) > Date.now() ? saved.sessionToken : null;
      state.sessionExpiresAt = Number(saved.expiresAt);
      state.sequence = Number(saved.sequence || 0);
      state.assignments = Array.isArray(saved.assignments) ? saved.assignments : [];
      state.answers = saved.answers && typeof saved.answers === "object" ? saved.answers : {};
      state.onceEvents = saved.onceEvents && typeof saved.onceEvents === "object" ? saved.onceEvents : {};
      state.config.activeVersionKey = saved.activeVersionKey || state.config.versionKey;
      state.config.resultLogic = saved.resultLogic || null;
      state.config.results = Array.isArray(saved.results) ? saved.results : [];
      if (saved.destinationUrl) state.config.destinationUrl = saved.destinationUrl;
      return Boolean(state.sessionToken);
    } catch (_) { return false; }
  }

  function archiveExpiredVisit(owner) {
    var pending = storageGet(browserStorage("sessionStorage"), queueKey());
    if (pending) {
      storageSet(browserStorage("sessionStorage"), queueKey() + "_expired_" + owner, pending);
      try { state.dropped += Math.max(state.queue.length, JSON.parse(pending).entries.length); } catch (_) { state.dropped += state.queue.length; }
    } else state.dropped += state.queue.length;
    storageRemove(browserStorage("sessionStorage"), queueKey());
    storageRemove(browserStorage("sessionStorage"), sessionKey());
    state.queue = [];
    state.sessionId = null;
    state.sessionToken = null;
    state.sessionExpiresAt = null;
    state.clientSessionKey = uuid();
    state.createdAt = Date.now();
    state.sequence = 0;
    state.answers = {};
    state.onceEvents = {};
    state.assignments = [];
    state.initAttempts = 0;
    state.failures = 0;
    state.retryAt = 0;
    state.blocked = null;
    publishHealth();
  }

  function saveSession(expiresInSeconds) {
    if (expiresInSeconds) state.sessionExpiresAt = Date.now() + Number(expiresInSeconds) * 1000;
    storageSet(browserStorage("sessionStorage"), sessionKey(), JSON.stringify({
      clientSessionKey: state.clientSessionKey,
      createdAt: state.createdAt,
      sessionId: state.sessionId,
      sessionToken: state.sessionToken,
      sequence: state.sequence,
      assignments: state.assignments,
      answers: state.answers,
      onceEvents: state.onceEvents,
      activeVersionKey: state.config.activeVersionKey || null,
      resultLogic: state.config.resultLogic || null,
      results: Array.isArray(state.config.results) ? state.config.results : [],
      destinationUrl: state.config.destinationUrl || null,
      expiresAt: state.sessionExpiresAt
    }));
  }

  function ensureSession() {
    if (!state.config) return Promise.resolve(null);
    if (!state.ownershipReady) return state.ownershipPromise.then(ensureSession);
    if (state.sessionExpiresAt && Date.now() >= state.sessionExpiresAt) state.sessionToken = null;
    if (state.sessionToken) return Promise.resolve(state.sessionId);
    if (state.blocked || Date.now() < state.retryAt) return Promise.resolve(null);
    if (state.initPromise) return state.initPromise;
    saveSession();
    state.initPromise = post("/api/quiz-collect/session", {
      clientSessionKey: state.clientSessionKey,
      versionKey: state.config.versionKey,
      isTest: state.config.isTest === true,
      visitorId: visitorId(),
      landingUrl: sanitizedLandingUrl(),
      referrer: document.referrer || null,
      attribution: attribution(),
      deviceType: deviceType(),
      deviceContext: {
        collectorVersion: "1.5.0",
        legacyUnownedEvents: state.legacyPending,
        storageWarning: state.storageWarning,
        ownershipWarning: state.ownershipWarning,
        viewportWidth: window.innerWidth || null,
        viewportHeight: window.innerHeight || null,
        language: window.navigator.language || null,
        timezone: (window.Intl && Intl.DateTimeFormat().resolvedOptions().timeZone) || null
      },
      noticeVersion: state.config.noticeVersion || null,
      fwExperimentId: state.config.fwExperimentId || null,
      experimentKey: state.config.experimentKey || null,
      variantKey: state.config.variantKey || null
      ,assignmentToken: assignmentToken()
    }).then(function (response) {
      if (state.sessionId && response.sessionId !== state.sessionId) {
        state.blocked = "session_owner_mismatch";
        throw new Error("Collector cannot move queued events to another session");
      }
      state.sessionId = response.sessionId;
      state.sessionToken = response.sessionToken;
      state.initAttempts = 0;
      state.failures = 0;
      state.retryAt = 0;
      state.assignments = Array.isArray(response.assignments) ? response.assignments : [];
      state.config.activeVersionKey = response.activeVersionKey || state.config.versionKey;
      if (Object.prototype.hasOwnProperty.call(response, "resultLogic")) {
        state.config.resultLogic = response.resultLogic || null;
      }
      if (Array.isArray(response.results)) state.config.results = response.results;
      if (response.destinationUrl) state.config.destinationUrl = response.destinationUrl;
      saveSession(response.expiresInSeconds);
      removeAssignmentTokenFromAddressBar();
      publishAssignments();
      publishRuntimeConfig();
      saveQueue();
      reportDiagnostics();
      try { window.dispatchEvent(new CustomEvent("nyquiz:session", { detail: { sessionId: state.sessionId } })); } catch (_) {}
      state.initPromise = null;
      flush();
      return state.sessionId;
    }).catch(function (error) {
      state.initPromise = null;
      if (error && error.status === 410) {
        if (state.releaseOwnership) { state.releaseOwnership(); state.releaseOwnership = null; }
        archiveExpiredVisit(state.clientSessionKey);
        saveSession();
        saveQueue();
        claimOwnership();
        window.setTimeout(ensureSession, 0);
        return null;
      }
      state.initAttempts += 1;
      state.failures += 1;
      state.deliveryFailures += 1;
      if (error && [400, 401, 403, 404, 409].indexOf(error.status) >= 0) state.blocked = "session_rejected_" + error.status;
      var delay = state.initAttempts >= MAX_ATTEMPTS ? RETRY_COOLDOWN_MS : Math.pow(2, state.initAttempts - 1) * 1000;
      state.retryAt = Date.now() + delay;
      if (!state.blocked) window.setTimeout(ensureSession, delay);
      saveQueue();
      return null;
    });
    return state.initPromise;
  }

  function publicEvent(entry) {
    return entry.event;
  }

  function nextBatch() {
    var batch = [];
    for (var i = 0; i < state.queue.length && batch.length < 50; i++) {
      var candidate = batch.concat(state.queue[i]);
      // Keepalive has a browser byte limit as well as the server's 64 KiB cap.
      var bytes = new Blob([JSON.stringify({ sessionToken: state.sessionToken, events: candidate.map(publicEvent) })]).size;
      if (bytes > 60 * 1024) break;
      batch = candidate;
    }
    if (!batch.length && state.queue.length) { state.blocked = "event_payload_too_large"; publishHealth(); }
    return batch;
  }

  function flush() {
    reconcileNow();
    if (!state.config || state.blocked || Date.now() < state.retryAt || state.flushing || !state.queue.length) return Promise.resolve(false);
    return ensureSession().then(function (sessionId) {
      if (!sessionId || state.flushing) return false;
      var batch = nextBatch();
      if (!batch.length) return false;
      state.flushing = true;
      return post("/api/quiz-collect/events", {
        sessionToken: state.sessionToken,
        events: batch.map(publicEvent)
      }, true).then(function () {
        var sent = {};
        batch.forEach(function (entry) { sent[entry.event.eventId] = true; });
        state.queue = state.queue.filter(function (entry) { return !sent[entry.event.eventId]; });
        state.failures = 0;
        state.retryAt = 0;
        state.lastSuccessAt = new Date().toISOString();
        reportDiagnostics();
        saveQueue();
        state.flushing = false;
        if (state.queue.length) window.setTimeout(flush, 0);
        return true;
      }).catch(function (error) {
        state.failures += 1;
        state.deliveryFailures += 1;
        state.flushing = false;
        if (error && error.status === 401) {
          state.sessionToken = null;
          state.sessionExpiresAt = null;
          saveSession();
        }
        if (error && [400, 403, 404, 409, 413].indexOf(error.status) >= 0) state.blocked = "events_rejected_" + error.status;
        var delay = state.failures >= MAX_ATTEMPTS ? RETRY_COOLDOWN_MS : Math.pow(2, state.failures) * 1000;
        state.retryAt = Date.now() + delay;
        saveQueue();
        if (!state.blocked) window.setTimeout(flush, delay);
        return false;
      });
    });
  }

  function track(type, data, onceKey) {
    if (!state.config || EVENT_TYPES.indexOf(type) < 0) return null;
    if (onceKey && state.ownershipReady && state.onceEvents[onceKey]) return state.onceEvents[onceKey];
    data = data || {};
    if (state.queue.length >= MAX_QUEUE) {
      state.dropped += 1;
      saveQueue();
      return null;
    }
    state.sequence += 1;
    var event = {
      eventId: uuid(),
      sequence: state.sequence,
      type: type,
      occurredAt: new Date().toISOString()
    };
    ["screenKey", "questionKey", "answerValue", "answerLabel", "resultKey", "properties"].forEach(function (key) {
      if (Object.prototype.hasOwnProperty.call(data, key) && data[key] !== undefined) event[key] = data[key];
    });
    if (type === "answer" && data.questionKey && Object.prototype.hasOwnProperty.call(data, "answerValue")) {
      state.answers[data.questionKey] = data.answerValue;
    }
    state.queue.push({ event: event, queuedAt: Date.now(), onceKey: onceKey || null });
    if (onceKey && state.ownershipReady) state.onceEvents[onceKey] = event.eventId;
    saveQueue();
    saveSession();
    if (state.queue.length >= 5) flush();
    return event.eventId;
  }

  function identify(data) {
    if (!state.config) return Promise.resolve(false);
    data = data || {};
    return ensureSession().then(function (sessionId) {
      if (!sessionId) return false;
      return post("/api/quiz-collect/identity", {
        sessionToken: state.sessionToken,
        firstName: data.firstName || null,
        lastName: data.lastName || null,
        email: data.email || null,
        phone: data.phone || null,
        externalCustomerId: data.externalCustomerId || null,
        noticeVersion: data.noticeVersion || state.config.noticeVersion || null
      }).then(function () { return true; }).catch(function () { return false; });
    });
  }

  // Duplicate-tab can copy sessionStorage. A browser lock prevents two live
  // documents from writing the same visit, while a reload resumes that visit.
  function claimOwnership() {
    var inheritedSequence = state.sequence;
    state.ownershipReady = false;
    state.ownershipPromise = new Promise(function (resolve) {
      function forkVisit() {
        // Keep only events created by this document after init. The other
        // tab still owns the copied pending events and their original IDs.
        state.queue = state.queue.filter(function (entry) { return entry.event.sequence > inheritedSequence; });
        state.clientSessionKey = uuid();
        state.sessionId = null;
        state.sessionToken = null;
        state.sessionExpiresAt = null;
        state.createdAt = Date.now();
        state.sequence = 0;
        state.answers = {};
        state.assignments = [];
        state.onceEvents = {};
        state.queue.forEach(function (entry) {
          entry.event.sequence = ++state.sequence;
          if (entry.event.type === "answer") state.answers[entry.event.questionKey] = entry.event.answerValue;
        });
        inheritedSequence = 0;
        state.dropped = 0;
        state.deliveryFailures = 0;
        state.diagnosticSignature = null;
        saveSession();
        saveQueue();
      }
      function settleVisit() {
        state.ownershipReady = true;
        state.ownershipWarning = null;
        // Only newly queued events need once-per-visit deduplication. An
        // inherited pending event must still be delivered after a reload.
        state.queue = state.queue.filter(function (entry) {
          if (!entry.onceKey || entry.event.sequence <= inheritedSequence) return true;
          if (state.onceEvents[entry.onceKey]) return false;
          state.onceEvents[entry.onceKey] = entry.event.eventId;
          return true;
        });
        saveSession();
        saveQueue();
      }
      // BroadcastChannel retains reload continuity on browsers without Web
      // Locks. A live owner answers a probe; simultaneous probes elect one
      // document deterministically before any request or delivery is allowed.
      function broadcastClaim() {
        if (typeof window.BroadcastChannel !== "function") {
          state.ownershipWarning = "tab_ownership_not_supported";
          state.ownershipReady = true;
          publishHealth(); resolve(); return;
        }
        var channel, timer, documentId = uuid();
        function leave() { if (timer) window.clearTimeout(timer); if (channel) channel.close(); }
        function forkAndClaim() { leave(); forkVisit(); broadcastClaim(); }
        try {
          channel = new window.BroadcastChannel("nyquiz_visit_" + state.clientSessionKey);
          channel.onmessage = function (message) {
            var data = message.data || {};
            if (data.id === documentId) return;
            if (data.type === "probe") {
              if (state.ownershipReady || documentId < data.id) channel.postMessage({type:"owner",id:documentId,target:data.id});
              else forkAndClaim();
            } else if (data.type === "owner" && data.target === documentId && !state.ownershipReady) forkAndClaim();
          };
          state.releaseOwnership = leave;
          channel.postMessage({type:"probe",id:documentId});
          timer = window.setTimeout(function () { settleVisit(); resolve(); }, 200);
        } catch (_) {
          leave(); state.ownershipReady = true; state.ownershipWarning = "tab_ownership_check_failed"; publishHealth(); resolve();
        }
      }
      if (!window.navigator.locks || typeof window.navigator.locks.request !== "function") {
        broadcastClaim(); return;
      }
      function claim() {
        window.navigator.locks.request("nyquiz_visit_" + state.clientSessionKey, { ifAvailable: true }, function (lock) {
          if (!lock) {
            forkVisit();
            return claim();
          }
          settleVisit();
          resolve();
          return new Promise(function (release) { state.releaseOwnership = release; });
        }).catch(function () {
          state.ownershipReady = true;
          state.ownershipWarning = "tab_ownership_check_failed";
          publishHealth();
          resolve();
        });
      }
      claim();
    });
  }

  function init(config) {
    if (!config || !config.quizKey || !config.versionKey) return Promise.resolve(null);
    if (state.config) {
      if (state.config.quizKey === config.quizKey && state.config.versionKey === config.versionKey) return ensureSession();
      state.blocked = "collector_reinitialized_for_another_quiz";
      publishHealth();
      return Promise.resolve(null);
    }
    state.config = config;
    try { state.config.isTest = config.isTest === true || new URLSearchParams(window.location.search).get("nyq_test") === "1"; } catch (_) {}
    state.endpoint = config.endpoint || sdkOrigin || window.location.origin;
    var restored = restoreSession();
    if (!state.clientSessionKey) state.clientSessionKey = uuid();
    if (!state.createdAt) state.createdAt = Date.now();
    state.queue = loadQueue();
    saveSession();
    claimOwnership();
    publishHealth();
    if (!state.timer) state.timer = window.setInterval(flush, FLUSH_MS);
    var promise = ensureSession();
    if (restored) window.setTimeout(function () {
      publishAssignments();
      publishRuntimeConfig();
    }, 0);
    return promise;
  }

  function beaconFlush() {
    reconcileNow();
    if (!state.config || !state.ownershipReady || !state.sessionToken || !state.queue.length || !window.navigator.sendBeacon) return;
    if (state.blocked) return;
    var batch = nextBatch();
    if (!batch.length) return;
    try {
      var body = JSON.stringify({ sessionToken: state.sessionToken, events: batch.map(publicEvent) });
      window.navigator.sendBeacon(endpoint("/api/quiz-collect/events"), new Blob([body], { type: "text/plain" }));
    } catch (_) {}
  }

  window.addEventListener("online", function () {
    if (state.blocked) return;
    state.initAttempts = 0;
    state.failures = 0;
    state.retryAt = 0;
    ensureSession().then(flush);
  });
  window.addEventListener("pagehide", function () {
    beaconFlush();
    if (state.releaseOwnership) { state.releaseOwnership(); state.releaseOwnership = null; }
  });
  window.addEventListener("pageshow", function (event) {
    if (event.persisted && state.config) { claimOwnership(); ensureSession().then(flush); }
  });
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") beaconFlush();
  });

  function getAssignments() { return state.assignments.slice(); }

  function getSessionId() { return state.sessionId || null; }

  function registerReconciler(reconciler) {
    if (typeof reconciler !== "function") return false;
    state.reconcilers.push(reconciler);
    return true;
  }

  function reconcileNow() {
    state.reconcilers.forEach(function (reconciler) {
      try { reconciler(); } catch (_) {}
    });
  }

  function sameValue(left, right) {
    if (left === undefined) return false;
    if ((left && typeof left === "object") || (right && typeof right === "object")) {
      try { return JSON.stringify(left) === JSON.stringify(right); } catch (_) { return false; }
    }
    return left === right;
  }

  function containsValue(answer, expected) {
    if (answer === undefined || answer === null) return false;
    if (Array.isArray(answer)) return answer.some(function (item) { return sameValue(item, expected); });
    return typeof answer === "string" && typeof expected === "string" && answer.indexOf(expected) >= 0;
  }

  function conditionMatches(condition, answers) {
    var answer = answers[condition.questionKey];
    if (answer === undefined) return false;
    if (condition.operator === "equals") return sameValue(answer, condition.value);
    if (condition.operator === "not_equals") return !sameValue(answer, condition.value);
    if (condition.operator === "contains") return containsValue(answer, condition.value);
    if (condition.operator === "not_contains") return !containsValue(answer, condition.value);
    return false;
  }

  function resolveResult(answers) {
    var logic = state.config && state.config.resultLogic;
    if (!logic || !Array.isArray(logic.rules)) return null;
    var values = answers || state.answers;
    for (var index = 0; index < logic.rules.length; index += 1) {
      var rule = logic.rules[index];
      if (!rule || !Array.isArray(rule.conditions) || !rule.conditions.length) continue;
      var matches = rule.match === "any"
        ? rule.conditions.some(function (condition) { return conditionMatches(condition, values); })
        : rule.conditions.every(function (condition) { return conditionMatches(condition, values); });
      if (matches) return rule.resultKey || null;
    }
    return logic.fallbackResultKey || null;
  }

  function getResult(answers) {
    var key = resolveResult(answers);
    var results = state.config && Array.isArray(state.config.results) ? state.config.results : [];
    for (var index = 0; index < results.length; index += 1) {
      if (results[index] && results[index].key === key) return results[index];
    }
    return key ? { key: key, label: key } : null;
  }

  function getAnswers() {
    var copy = {};
    Object.keys(state.answers).forEach(function (key) { copy[key] = state.answers[key]; });
    return copy;
  }

  window.NyQuiz = {
    init: init,
    track: track,
    trackOnce: function (type, data) { return track(type, data, type); },
    identify: identify,
    flush: flush,
    getAssignments: getAssignments,
    getSessionId: getSessionId,
    getHealth: getHealth,
    getAnswers: getAnswers,
    registerReconciler: registerReconciler,
    reconcileNow: reconcileNow,
    resolveResult: resolveResult,
    getResult: getResult,
    version: "1.5.0"
  };
})(window, document);

import {ReferenceFlow,validateAnswer} from './pg-reference-state-20d1346e5f70.js';
const app=document.querySelector('#pg-men-app');
const definition=await fetch(app.dataset.flowUrl).then(r=>{if(!r.ok)throw Error('Flow definition unavailable');return r.json();});
const flow=new ReferenceFlow(definition);
const annualResumeConfig={"versionKey":"pg-73a023c12b3408e5","sourceUrl":"https://pilatesguide.org/pages/calisthenics-plan","resultScreens":["s51"],"completeScreens":["s53"],"quizKey":"pg-betterme-men","screens":[{"key":"s00","type":"single","label":"BODYWEIGHT TRAINING PLAN","questionKey":"s00","question":"BODYWEIGHT TRAINING PLAN","options":[{"key":"o1","label":"Age: 18-29"},{"key":"o2","label":"Age: 30-39"},{"key":"o3","label":"Age: 40-49"},{"key":"o4","label":"Age: 50+"}]},{"key":"s01","type":"information","label":"Over 430,000 men"},{"key":"s02","type":"single","label":"Have you practiced any mat Pilates before?","questionKey":"s02","question":"Have you practiced any mat Pilates before?","options":[{"key":"o1","label":"Yes"},{"key":"o2","label":"No"}]},{"key":"s54","type":"information","label":"Build on what you know!"},{"key":"s03","type":"information","label":"Start a workout routine using your own body weight"},{"key":"s04","type":"single","label":"What do you want most?","questionKey":"s04","question":"What do you want most?","options":[{"key":"o1","label":"Gain muscle"},{"key":"o2","label":"Lose weight"},{"key":"o3","label":"Lose fat and gain muscle"},{"key":"o4","label":"Improve overall fitness"}]},{"key":"s05","type":"information","label":"Your goal gives this routine a focus"},{"key":"s06","type":"multi","label":"Which other goals would you like to work toward?","questionKey":"s06","question":"Which other goals would you like to work toward?","options":[{"key":"o1","label":"Increase stamina and endurance"},{"key":"o2","label":"Improve posture"},{"key":"o3","label":"Develop flexibility"},{"key":"o4","label":"Boost sexual drive"},{"key":"o5","label":"None of the above"}]},{"key":"s07","type":"single","label":"Which body shape feels most like yours today?","questionKey":"s07","question":"Which body shape feels most like yours today?","options":[{"key":"o1","label":"Slender"},{"key":"o2","label":"Medium build"},{"key":"o3","label":"Stocky"},{"key":"o4","label":"Significantly overweight"}]},{"key":"s08","type":"single","label":"Your ideal body shape?","questionKey":"s08","question":"Your ideal body shape?","options":[{"key":"o1","label":"A few sizes smaller"},{"key":"o2","label":"Athletic"},{"key":"o3","label":"Shredded"},{"key":"o4","label":"Swole"}]},{"key":"s09","type":"single","label":"When were you happiest with your overall fitness?","questionKey":"s09","question":"When were you happiest with your overall fitness?","options":[{"key":"o1","label":"Less than a year ago"},{"key":"o2","label":"1 to 2 years ago"},{"key":"o3","label":"More than 3 years ago"},{"key":"o4","label":"Never"}]},{"key":"s10","type":"single","label":"Which weight pattern sounds familiar?","questionKey":"s10","question":"Which weight pattern sounds familiar?","options":[{"key":"o1","label":"Putting on weight or muscle takes effort"},{"key":"o2","label":"I gain and lose weight easily"},{"key":"o3","label":"Weight comes on more easily than it comes off"}]},{"key":"s11","type":"information","label":"Start with the pattern you recognize"},{"key":"s12","type":"single","label":"What is your current push-up range?","questionKey":"s12","question":"What is your current push-up range?","options":[{"key":"o1","label":"I can't do push-ups"},{"key":"o2","label":"1-10 push-ups"},{"key":"o3","label":"11-20 push-ups"},{"key":"o4","label":"20+ push-ups"}]},{"key":"s13","type":"single","label":"How many squats can you do at once?","questionKey":"s13","question":"How many squats can you do at once?","options":[{"key":"o1","label":"I can't do squats"},{"key":"o2","label":"11-20 squats"},{"key":"o3","label":"21-40 squats"},{"key":"o4","label":"40+ squats"}]},{"key":"s14","type":"single","label":"How far can you bend?","questionKey":"s14","question":"How far can you bend?","options":[{"key":"o1","label":"Very flexible"},{"key":"o2","label":"Pretty flexible"},{"key":"o3","label":"Not that good"},{"key":"o4","label":"I’m not sure"}]},{"key":"s15","type":"single","label":"How regularly have you trained over the past three months?","questionKey":"s15","question":"How regularly have you trained over the past three months?","options":[{"key":"o1","label":"Almost every day"},{"key":"o2","label":"Several times a week"},{"key":"o3","label":"Several times a month"},{"key":"o4","label":"I don't work out"}]},{"key":"s16","type":"information","label":"Let a small start become a habit"},{"key":"s17","type":"multi","label":"Which areas need attention?","questionKey":"s17","question":"Which areas need attention?","options":[{"key":"o1","label":"Belly"},{"key":"o2","label":"Pecs"},{"key":"o3","label":"Arms"},{"key":"o4","label":"Legs"},{"key":"o5","label":"Back"},{"key":"o6","label":"Full body"}]},{"key":"s18","type":"information","label":"Train at home to build strength from head to toe"},{"key":"s19","type":"single","label":"How many days can you set aside for exercise?","questionKey":"s19","question":"How many days can you set aside for exercise?","options":[{"key":"o1","label":"1-2 times"},{"key":"o2","label":"3-4 times"},{"key":"o3","label":"5+ times"}]},{"key":"s20","type":"single","label":"How much time can you give each session?","questionKey":"s20","question":"How much time can you give each session?","options":[{"key":"o1","label":"10-15 min"},{"key":"o2","label":"15-20 min"},{"key":"o3","label":"20-25 min"},{"key":"o4","label":"25+ min"},{"key":"o5","label":"I don’t know"}]},{"key":"s21","type":"multi","label":"Do any of these issues affect your movement?","questionKey":"s21","question":"Do any of these issues affect your movement?","options":[{"key":"o1","label":"Sensitive back"},{"key":"o2","label":"Sensitive knees"},{"key":"o3","label":"None of the above"}]},{"key":"s22","type":"information","label":"Noted, thanks!"},{"key":"s23","type":"single","label":"What is your usual work pattern?","questionKey":"s23","question":"What is your usual work pattern?","options":[{"key":"o1","label":"9 to 5"},{"key":"o2","label":"Night shifts"},{"key":"o3","label":"My hours are flexible"},{"key":"o4","label":"I am not currently working"}]},{"key":"s24","type":"single","label":"How much movement is in a normal day?","questionKey":"s24","question":"How much movement is in a normal day?","options":[{"key":"o1","label":"Mostly sitting"},{"key":"o2","label":"Constantly on my feet"},{"key":"o3","label":"Balance of sitting and moving"},{"key":"o4","label":"Activity level changes daily"}]},{"key":"s25","type":"single","label":"How much energy do you have on most days?","questionKey":"s25","question":"How much energy do you have on most days?","options":[{"key":"o1","label":"Low and inconsistent"},{"key":"o2","label":"Remain steady"},{"key":"o3","label":"Fluctuate throughout the day"},{"key":"o4","label":"Stay high all day"}]},{"key":"s26","type":"information","label":"Find more energy in everyday movement"},{"key":"s27","type":"single","label":"How much water do you drink?","questionKey":"s27","question":"How much water do you drink?","options":[{"key":"o1","label":"I only have coffee or tea"},{"key":"o2","label":"About 2 glasses"},{"key":"o3","label":"2 to 6 glasses"},{"key":"o4","label":"More than 6 glasses"}]},{"key":"s28","type":"single","label":"How many hours are you sleeping?","questionKey":"s28","question":"How many hours are you sleeping?","options":[{"key":"o1","label":"Less than 5 hours"},{"key":"o2","label":"5-6 hours"},{"key":"o3","label":"7-8 hours"},{"key":"o4","label":"More than 8 hours"}]},{"key":"s29","type":"multi","label":"Which of these habits are familiar to you?","questionKey":"s29","question":"Which of these habits are familiar to you?","options":[{"key":"o1","label":"Emotional or boredom eating"},{"key":"o2","label":"Overeating"},{"key":"o3","label":"Late-night snacking"},{"key":"o4","label":"Skipping meals too often"},{"key":"o5","label":"None of the above"}]},{"key":"s30","type":"multi","label":"What do you most often want to eat?","questionKey":"s30","question":"What do you most often want to eat?","options":[{"key":"o1","label":"Sweet treats"},{"key":"o2","label":"Salty snacks"},{"key":"o3","label":"Fast food"},{"key":"o4","label":"Soda"},{"key":"o5","label":"None of the above"}]},{"key":"s31","type":"single","label":"Which eating style fits you best?","questionKey":"s31","question":"Which eating style fits you best?","options":[{"key":"o1","label":"Traditional I enjoy everything"},{"key":"o2","label":"Keto Mostly fat, with fewer carbohydrates"},{"key":"o3","label":"Paleo I don't eat processed foods"},{"key":"o4","label":"Vegetarian I avoid meat and fish"},{"key":"o5","label":"Vegan (Plant Diet) I do not eat animal products"},{"key":"o6","label":"Keto Vegan Plant-based with a lower carbohydrate intake"},{"key":"o7","label":"Mediterranean Vegetables, grains and fish are regular choices"},{"key":"o8","label":"Pescatarian I avoid meat but enjoy fish"},{"key":"o9","label":"Lactose Free Lactose is excluded from my meals"},{"key":"o10","label":"Gluten Free I leave gluten-containing grains out"}]},{"key":"s32","type":"information","label":"Give your meals a place alongside your training"},{"key":"s33","type":"single","label":"Smoke at all?","questionKey":"s33","question":"Smoke at all?","options":[{"key":"o1","label":"Yes, regularly"},{"key":"o2","label":"Only occasionally"},{"key":"o3","label":"Only when I drink"},{"key":"o4","label":"No, I've quit"},{"key":"o5","label":"No, I've never smoked"}]},{"key":"s34","type":"single","label":"How often do you have alcohol?","questionKey":"s34","question":"How often do you have alcohol?","options":[{"key":"o1","label":"Several times a week"},{"key":"o2","label":"Several times a month"},{"key":"o3","label":"On rare special occasions"},{"key":"o4","label":"Never"}]},{"key":"s35","type":"multi","label":"Which recent changes have made a fitness routine harder to maintain?","questionKey":"s35","question":"Which recent changes have made a fitness routine harder to maintain?","options":[{"key":"o1","label":"Work pressure"},{"key":"o2","label":"Busy family life"},{"key":"o3","label":"Divorce or breakup"},{"key":"o4","label":"Slower metabolism due to aging"},{"key":"o5","label":"Financial challenges"},{"key":"o6","label":"Covid-19 pandemic"},{"key":"o7","label":"Other stressful events"},{"key":"o8","label":"None of the above"}]},{"key":"s36","type":"information","label":"Meet the coaches featured in the reference program"},{"key":"s37","type":"number","label":"How tall are you?","questionKey":"s37","question":"How tall are you?"},{"key":"s38","type":"number","label":"What do you weigh now?","questionKey":"s38","question":"What do you weigh now?"},{"key":"s39","type":"number","label":"What is your target weight?","questionKey":"s39","question":"What is your target weight?"},{"key":"s40","type":"number","label":"How old are you?","questionKey":"s40","question":"How old are you?"},{"key":"s41","type":"information","label":"Your starting profile"},{"key":"s42","type":"single","label":"Is there an occasion you are preparing for?","questionKey":"s42","question":"Is there an occasion you are preparing for?","options":[{"key":"o1","label":"Vacation"},{"key":"o2","label":"Competition"},{"key":"o3","label":"Important date"},{"key":"o4","label":"Outdoor adventure"},{"key":"o5","label":"Birthday"},{"key":"o6","label":"Holiday"},{"key":"o7","label":"Reunion"},{"key":"o8","label":"Family occasion"},{"key":"o9","label":"Wedding"},{"key":"o10","label":"Other"},{"key":"o11","label":"No events any time soon"}]},{"key":"s43","type":"information","label":"Your training outline, with a goal to work toward"},{"key":"s44","type":"multi","label":"What has made your fitness progress hard?","questionKey":"s44","question":"What has made your fitness progress hard?","options":[{"key":"o1","label":"Lack of motivation"},{"key":"o2","label":"Didn't have a clear plan"},{"key":"o3","label":"Lack of time"},{"key":"o4","label":"Injuries or pain"},{"key":"o5","label":"None of the above"}]},{"key":"s45","type":"information","label":"Flo Pilates will keep you on track!"},{"key":"s46","type":"multi","label":"What would make this change worthwhile for you?","questionKey":"s46","question":"What would make this change worthwhile for you?","options":[{"key":"o1","label":"Feel more confident in my appearance"},{"key":"o2","label":"Feel more confident in my body"},{"key":"o3","label":"Make room for a healthier routine"},{"key":"o4","label":"Handle everyday physical tasks more easily"},{"key":"o5","label":"Feel more capable and ready for the day"},{"key":"o6","label":"Other"}]},{"key":"s47","type":"single","label":"How confident do you feel about reaching your goal by December 16?","questionKey":"s47","question":"How confident do you feel about reaching your goal by December 16?","options":[{"key":"o1","label":"I believe I can do it!"},{"key":"o2","label":"I have doubts, but I am ready to begin"},{"key":"o3","label":"I’m still really unsure"}]},{"key":"s48","type":"information","label":"Putting your personal Mat Pilates plan together"},{"key":"s49","type":"text","label":"Where should we send the details of your Mat Pilates Workout Plan for your selected training goal?","questionKey":"s49","question":"Where should we send the details of your Mat Pilates Workout Plan for your selected training goal?"},{"key":"s50","type":"text","label":"What should we call you?","questionKey":"s50","question":"What should we call you?"},{"key":"s51","type":"result","label":"{name}, your four-week bodyweight training outline is ready to explore."},{"key":"s52","type":"information","label":"Reveal the offer for your training plan"},{"key":"s53","type":"offer","label":"Your Mat Pilates Workout Plan is ready!"}],"numberUnits":{"s37":"cm","s38":"kg","s39":"kg","s40":"years"}};
const restoredJourney=await restoreAnnualJourney({app,flow,definition,config:annualResumeConfig,sdk:window.NyQuiz,restoreFields:false});
const pgAnalytics=createPgQuizBridge({app,flow,definition,config:annualResumeConfig});


let panels=[...app.querySelectorAll('[data-flow-screen]')];
let editorPanel=null,timer=null,selectedPlan=0,offerSeconds=600,offerTimer=null;
const editorAnswers={},editorHistory=[];
let editorNavigating=false;
const answers=()=>editorPanel?{...flow.answers,...editorAnswers}:flow.answers;
function selectEditor(id){editorNavigating=false;editorPanel=id;editorHistory.splice(0,editorHistory.length,id);show();}
function advanceEditor(value){
 const screen=definition.screens.find(s=>s.id===editorPanel);
 if(validateAnswer(screen.input,value)){error('Choose a valid answer before continuing.');return;}
 editorAnswers[editorPanel]=value;
 const answers={...flow.answers,...editorAnswers};
 const matches=c=>c.operator==='equals'?JSON.stringify(answers[c.screen])===JSON.stringify(c.value):c.operator==='includes'?answers[c.screen]?.includes(c.value):c.operator==='answered'?answers[c.screen]!==undefined:c.operator==='gte'?answers[c.screen]>=c.value:answers[c.screen]<=c.value;
 const next=screen.routes?.find(r=>r.when.every(matches))?.to||screen.next;
 if(next){editorNavigating=true;editorPanel=next;editorHistory.push(next);show();}
}
function backEditor(){if(editorHistory.length>1){editorHistory.pop();editorPanel=editorHistory.at(-1);show();}}
const panel=()=>panels.find(p=>p.dataset.flowScreen===(editorPanel||flow.current.id));
const fields=p=>[...p.querySelectorAll('[data-flow-input]')];
const metric=p=>p?.querySelector('[data-flow-unit="metric"]')?.getAttribute('aria-pressed')==='true';
const resultTextTemplates=new WeakMap();
const options=p=>[...p.querySelectorAll('[data-flow-option]')];
const selected=e=>e.getAttribute(e.getAttribute('role')==='option'?'aria-selected':'aria-checked')==='true';
function setSelected(e,value){e.setAttribute(e.getAttribute('role')==='option'?'aria-selected':'aria-checked',String(value));const zone=e.closest('[data-flow-screen]')?.querySelector('[data-body-zone="'+e.dataset.flowOption+'"]');if(zone)zone.hidden=!value;}
function error(message){let p=panel(),e=p.querySelector('[data-flow-error]');if(!e){e=document.createElement('p');e.dataset.flowError='';e.className='pg-flow-error';e.setAttribute('role','alert');(p.querySelector('form')||p).append(e);}e.textContent=message;e.hidden=!message;}
function value(p){const id=p.dataset.flowScreen,def=definition.screens.find(x=>x.id===id),f=fields(p);
 if(def.input?.type==='multi')return options(p).filter(selected).map(e=>e.dataset.flowOption);
 if(def.input?.type==='single')return options(p).find(selected)?.dataset.flowOption;
 if(!f.length)return undefined;
 if(!f[0].value.trim())return undefined;
 if(id==='s37')return metric(p)?Number(f[0].value):(Number(f[0].value)*12+Number(f[1]?.value||0))*2.54;
 if(['s38','s39'].includes(id))return Number(f[0].value)*(metric(p)?1:.45359237);
 return id==='s40'?Number(f[0].value):f[0].value.trim();
}
function currentLabel(id){const v=answers()[id];return panels.find(p=>p.dataset.flowScreen===id)?.querySelector('[data-flow-option="'+v+'"]')?.dataset.flowLabel||'';}
function updateWeightNote(){const p=panel(),id=p.dataset.flowScreen;if(!['s38','s39','s40'].includes(id))return;const title=p.querySelector('.note-card_title__yeYJj'),card=title?.closest('.note-card_container__XXoT6'),answer=value(p);if(!title||!card)return;card.hidden=!answer||(id==='s40'&&(answer<18||answer>120));if(card.hidden)return;
 if(id==='s38'){const height=answers().s37;card.hidden=!height;if(card.hidden)return;const bmi=answer/(height/100)**2,label=bmi<18.5?'underweight':bmi<25?'normal':bmi<30?'overweight':'obese';title.textContent='Your calculated BMI is '+Number(bmi.toFixed(1))+', in the category '+label;}
 if(id==='s39'){const current=answers().s38;card.hidden=!current;if(card.hidden)return;const pct=Math.round(Math.abs(current-answer)/current*100);title.textContent=current===answer?'Your goal: maintain your current weight':'Your goal: '+(answer<current?'lose ':'gain ')+pct+'% of your weight';}
}
function personalize(){syncMenAnswerProfile(panel(),answers());const a=answers(),id=panel().dataset.flowScreen,isMetric=metric(panels.find(x=>x.dataset.flowScreen==='s39')),weightUnit=isMetric?'kg':'lbs',displayWeight=kg=>isMetric?kg:kg/.45359237;
 if(id==='s41')panel().querySelectorAll('[data-summary-answer]').forEach(e=>{const screen=e.dataset.summaryAnswer;const choice=panels.find(p=>p.dataset.flowScreen===screen)?.querySelector('[data-flow-option="'+a[screen]+'"]');const label=choice?.textContent?.trim();if(label)e.textContent=label;});
 if(id==='s41'&&a.s37&&a.s38){const bmi=a.s38/(a.s37/100)**2;panel().querySelectorAll('p,span').forEach(e=>{if(e.children.length===0&&/^You\s*[-–]/.test(e.textContent))e.textContent='You - '+bmi.toFixed(2);});const band=bmi<18.5?0:bmi<25?1:bmi<30?2:3,ranges=[15,18.5,25,30,40],position=Math.max(0,Math.min(100,band*25+(bmi-ranges[band])/(ranges[band+1]-ranges[band])*25));panel().querySelector('.bmi-scale_slider__mFSBP').style.insetInlineStart='calc('+position+'% - 8px)';panel().querySelectorAll('.bmi-scale_scaleValue__pXUQV').forEach((e,i)=>e.classList.toggle('bmi-scale_isSelected__QKL23',i===band));}
 if(id==='s01'&&a.s00){const i=Number(a.s00.slice(1))-1;panel().querySelector('[data-age-proof-count]').textContent='Mat Pilates for men';panel().querySelector('[data-age-proof-band]').textContent=['your 20s,','your 30s,','your 40s,','50+,'][i];panel().querySelector('[data-test="infoPage__subtitle"] span').textContent=i===3?'At':'In';}
 if(id==='s43'&&a.s38&&a.s39){const current=displayWeight(a.s38),target=displayWeight(a.s39),diff=current-target,direction=Math.abs(diff)<.0001?'maintain':diff>0?'lose':'gain';panel().dataset.weightDirection=direction;panel().querySelectorAll('[data-chart-number]').forEach(e=>{e.textContent=Math.round(direction==='maintain'?(e.closest('.graph-weight-labels_container__VobHz')?current+(Number(e.dataset.chartNumber)-181)/3:target):target+(Number(e.dataset.chartNumber)-175)/15*diff);e.parentElement.childNodes.forEach(n=>{if(n.nodeType===3&&/^\s*(lbs|kg)\s*$/.test(n.textContent))n.textContent=' '+weightUnit;});});panel().querySelectorAll('[data-chart-label]').forEach(e=>{const label=e.dataset.chartLabel;e.textContent=label==='175 lbs'?Math.round(target)+' '+weightUnit:label==='Lose 15 lbs'?(direction==='maintain'?'Maintain '+Math.round(target):(direction==='gain'?'Gain ':'Lose ')+Math.round(Math.abs(diff)))+' '+weightUnit:(direction==='maintain'?'0':(direction==='gain'?'+':'-')+(label==='-15 lbs'?Math.round(Math.abs(diff)):(Math.abs(diff)*.52666667).toFixed(1)))+' '+weightUnit;});
 const graph=panel().querySelector('.weight-goal-graph_graphContainer__mUFnL');
 graph?.querySelectorAll('svg path[d]').forEach(path=>{path.dataset.sourcePath ||= path.getAttribute('d');path.setAttribute('d',direction==='maintain'?(path.parentElement.classList.contains('charts-common_graphArea__zOcnp')?'M0 68.4H286V168H0Z':'M0 68.4H286'):path.dataset.sourcePath);});
 graph?.querySelectorAll('.graph-goal-point_circleContainer__PZNfh').forEach(point=>{point.dataset.sourcePosition ||= point.style.insetBlockStart;point.style.insetBlockStart=direction==='maintain'?'50%':point.dataset.sourcePosition;});
 const walker=document.createTreeWalker(panel(),NodeFilter.SHOW_TEXT);let node;while(node=walker.nextNode()){if(/sustainable weight loss/.test(node.textContent)||resultTextTemplates.has(node)){const template=resultTextTemplates.get(node)||node.textContent;resultTextTemplates.set(node,template);node.textContent=direction==='lose'?template:template.replace('sustainable weight loss','sustainable fitness');}}
 }
 if(['s43','s51'].includes(id)&&a.s38&&a.s39){panel().querySelectorAll('[data-current-weight]').forEach(e=>e.textContent=Math.round(displayWeight(a.s38)));panel().querySelectorAll('[data-goal-weight]').forEach(e=>{e.textContent=Math.round(displayWeight(a.s39));e.parentElement.childNodes.forEach(n=>{if(n.nodeType===3)n.textContent=n.textContent.replace(/\b(lbs|kg)\b/g,weightUnit);});});}
 if(id==='s51'&&a.s39){const walker=document.createTreeWalker(panel(),NodeFilter.SHOW_TEXT);let node;while(node=walker.nextNode()){if(/175 lbs/.test(node.textContent)||resultTextTemplates.has(node)){const template=resultTextTemplates.get(node)||node.textContent;resultTextTemplates.set(node,template);node.textContent=template.replace(/175 lbs/g,Math.round(displayWeight(a.s39))+' '+weightUnit);}}}
 if(id==='s51'){panel().querySelectorAll('h1,h2,p,span,strong').forEach(e=>{if(e.children.length===0){if(e.textContent.trim()==='Research'||e.dataset.resultName){e.dataset.resultName='true';e.textContent=a.s50||'Your';}if((/175 lbs/.test(e.textContent)||e.dataset.resultWeightTemplate)&&a.s39){e.dataset.resultWeightTemplate ||= e.textContent;e.textContent=e.dataset.resultWeightTemplate.replace('175 lbs',Math.round(displayWeight(a.s39))+' '+weightUnit);}}});}
}
function updatePlans(){const offer=panels.at(-1);offer.querySelectorAll('[data-offer-plan]').forEach(e=>{e.setAttribute('aria-pressed','true');e.dataset.selected='true';e.classList.add('choose-plan-card-template_isSelected__YEOJt');});offer.querySelectorAll('[data-billing-summary]').forEach(e=>e.textContent="Pay $14.99 USD today for your first 28 days of your Flo subscription. Renews automatically at $39 USD every 28 days until canceled. No free trial. Review the subscription terms at checkout.");}
function expiredOfferLayout(){}
function startOfferTimer(){}
function carouselClone(slide,suffix){
 const clone=slide.cloneNode(true),nodes=[clone,...clone.querySelectorAll('*')],ids=new Map();
 for(const node of nodes)if(node.id){const old=node.id;node.id=old+'-'+suffix;ids.set(old,node.id);}
 for(const node of nodes)for(const attr of [...node.attributes])if(attr.name!=='id'){
  let value=attr.value;
  for(const [old,id] of ids){value=value.replaceAll('url(#'+old+')','url(#'+id+')');if(['href','xlink:href'].includes(attr.name)&&value==='#'+old)value='#'+id;if(['aria-controls','aria-labelledby','aria-describedby','for'].includes(attr.name))value=value.split(' ').map(x=>x===old?id:x).join(' ');}
  if(value!==attr.value)node.setAttribute(attr.name,value);
 }
 return clone;
}
const offerCarouselCleanups=new Map();
function initOfferCarousels(){
 panels.at(-1).querySelectorAll('[data-men-carousel]').forEach(root=>{
  if(root.dataset.initialized)return;root.dataset.initialized='true';root.tabIndex=0;
  let index=0,down=null,reset=null;
  const feature=root.dataset.menCarousel==='features',track=root.querySelector(feature?'.splide__track':'[data-men-story-track]'),list=feature?track.querySelector('.splide__list'):track,slides=[...list.children],dots=[...root.querySelectorAll('[role="tablist"] button')];
  if(feature){slides.forEach(s=>{const c=carouselClone(s,'before');c.dataset.carouselClone='before';c.setAttribute('aria-hidden','true');list.insertBefore(c,slides[0]);});slides.forEach(s=>{const c=carouselClone(s,'after');c.dataset.carouselClone='after';c.setAttribute('aria-hidden','true');list.append(c);});}
  const render=(draw=index,animated=true)=>{
   root.dataset.slide=String(index);if(!feature&&innerWidth>=1024){list.style.transform='';slides.forEach(s=>s.removeAttribute('aria-hidden'));return;}
   const step=slides.length>1?slides[1].offsetLeft-slides[0].offsetLeft:slides[0].getBoundingClientRect().width;
   const center=feature?(track.clientWidth-parseFloat(getComputedStyle(track).paddingLeft)-parseFloat(getComputedStyle(track).paddingRight)-slides[0].getBoundingClientRect().width)/2:0;
   list.style.transition=animated?'transform .4s ease':'none';list.style.transform='translateX('+(center-(draw+(feature?slides.length:0))*step)+'px)';
   slides.forEach((s,i)=>{s.classList.toggle('is-active',i===index);s.classList.toggle('is-visible',i===index);s.setAttribute('aria-hidden',String(i!==index));});
   dots.forEach((d,i)=>{d.classList.toggle('is-active',i===index);d.setAttribute('aria-selected',String(i===index));d.tabIndex=i===index?0:-1;});
  };
  const go=n=>{clearTimeout(reset);index=(n+slides.length)%slides.length;render(feature?n:index);if(feature&&n!==index)reset=setTimeout(()=>render(index,false),410);};
  dots.forEach((d,i)=>d.addEventListener('click',()=>go(i)));
  root.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1));}});
  root.addEventListener('pointerdown',e=>down=e.clientX);root.addEventListener('pointerup',e=>{if(down!==null&&Math.abs(e.clientX-down)>35)go(index+(e.clientX<down?1:-1));down=null;});
  const resized=()=>render(index,false);window.addEventListener('resize',resized);
  const tick=feature?setInterval(()=>{if(root.isConnected&&panel()?.dataset.flowScreen==='s53'&&!document.hidden&&!root.matches(':hover')&&!root.contains(document.activeElement))go(index+1);},4000):null;
  offerCarouselCleanups.set(root,()=>{clearTimeout(reset);clearInterval(tick);window.removeEventListener('resize',resized);});
  render(index,false);
 });
}

function syncOptionalContinue(){const p=panel(),b=p?.querySelector('[data-optional-answer-gate]');if(!b)return;const enabled=options(p).some(selected);b.disabled=!enabled;b.classList.toggle('button-module_disabled__yDPVE',!enabled);}
function show(id=editorPanel||flow.current.id){clearInterval(timer);panels.forEach(p=>p.hidden=p.dataset.flowScreen!==id);app.dataset.currentScreen=id;pgAnalytics.show(id);document.body.classList.toggle('pg-at-offer',id==='s53');window.scrollTo({top:0,left:0,behavior:'instant'});personalize();syncOptionalContinue();const h=panel().querySelector('h1,h2');if(h){h.tabIndex=-1;h.focus({preventScroll:true});}
 if(id==='s48'&&(!editorPanel||editorNavigating)){const started=Date.now(),p=panel(),circumference=2*Math.PI*103;let amount=0;timer=setInterval(()=>{amount=Math.min(100,Math.floor((Date.now()-started)/120));p.querySelector('[data-loader-value]').textContent=amount;p.querySelector('[role="progressbar"]').setAttribute('aria-valuenow',amount);p.querySelector('[data-loader-stroke]').style.strokeDashoffset=circumference*(1-amount/100);const slide=Math.min(2,Math.floor((Date.now()-started)/5000));p.querySelector('[data-loader-tray]').style.transform='translateX(-'+slide*100/3+'%)';p.querySelectorAll('[data-loader-tray] [role="option"]').forEach((e,i)=>{e.setAttribute('aria-selected',String(i===slide));e.classList.toggle('carousel__slide--visible',i===slide);e.classList.toggle('carousel__slide--hidden',i!==slide);});if(amount===100){clearInterval(timer);advance();}},100);}
 if(id==='s52'&&panel().dataset.revealed==='true'&&(!editorPanel||editorNavigating))armRevealAdvance(panel());
 if(['s38','s39','s40'].includes(id))updateWeightNote();if(id==='s53'){updatePlans();startOfferTimer();initOfferCarousels();}
}
function advance(explicit){let p=panel(),id=p.dataset.flowScreen,v=explicit===undefined?value(p):explicit;
 if(['s33','s34'].includes(id)&&explicit!==''&&!v){error('Select an answer, or skip this question.');syncOptionalContinue();return;}
 if(id==='s37'){if(!v||v<100||v>250){error(metric(p)?'Enter a height between 100 and 250 cm.':'Enter a height between 3 ft 4 in and 8 ft 2 in.');return;}}
 if(['s38','s39'].includes(id)&&(!v||v<25||v>450)){error(metric(p)?'Enter a weight between 25 and 450 kg.':'Enter a weight between 56 and 992 lbs.');return;}
 if(id==='s49'&&!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v||'')){error('Enter a valid email address.');return;}
 error('');if(editorPanel){advanceEditor(v);return;}
 const result=flow.next(v);if(!result.ok){error(result.error==='required'?'Choose an answer before continuing.':'Check your answer and try again.');return;}show();
}
function choose(e){const p=panel(),multi=definition.screens.find(s=>s.id===p.dataset.flowScreen).input?.type==='multi';if(multi){const turnOn=!selected(e);if(e.hasAttribute('data-exclusive')||options(p).some(x=>selected(x)&&x.hasAttribute('data-exclusive')))options(p).forEach(x=>setSelected(x,false));if(p.dataset.flowScreen==='s17'&&e.dataset.flowOption==='o6')options(p).forEach(x=>setSelected(x,turnOn));else{setSelected(e,turnOn);if(p.dataset.flowScreen==='s17')setSelected(options(p).at(-1),options(p).slice(0,-1).every(selected));}}else{options(p).forEach(x=>setSelected(x,x===e));if(definition.screens.find(s=>s.id===p.dataset.flowScreen).autoAdvance)advance(e.dataset.flowOption);}error('');syncOptionalContinue();}
function armRevealAdvance(p){clearTimeout(timer);timer=setTimeout(()=>{if(panel()===p&&p.dataset.flowScreen==='s52'&&p.dataset.revealed==='true')advance();},1800);}
function reveal(){const p=panel();if(!p.dataset.revealed){p.dataset.revealed='true';p.querySelectorAll('[class*="scratch-card_outerCard"],[class*="scratch-animation_hint"]').forEach(x=>x.hidden=true);}armRevealAdvance(p);}
app.addEventListener('submit',e=>{e.preventDefault();advance();});
app.addEventListener('click',event=>{const t=event.target,p=panel();
 if(t.closest('[data-flow-back]')){event.preventDefault();if(editorPanel){backEditor();}else if(flow.back())show();return;}
 const choice=t.closest('[data-flow-option]');if(choice){event.preventDefault();choose(choice);return;}
 const units=t.closest('[data-flow-unit]');if(units){event.preventDefault();error('');const isMetric=units.dataset.flowUnit==='metric';p.querySelectorAll('[data-flow-unit]').forEach(e=>e.setAttribute('aria-pressed',String(e===units)));const f=fields(p);f.forEach(e=>e.value='');const suffix=p.querySelectorAll('[class*="postfix"]');if(suffix[0])suffix[0].textContent=p.dataset.flowScreen==='s37'?(isMetric?'cm':'ft'):(isMetric?'kg':'lbs');if(p.dataset.flowScreen==='s37'&&f[1]){f[1].parentElement.hidden=isMetric;f[0].setAttribute('aria-label',isMetric?'Height in centimeters':'Feet');}updateWeightNote();return;}
 if(t.closest('[data-flow-skip]')){event.preventDefault();advance('');return;}
 if(t.closest('[data-flow-next]')){event.preventDefault();advance();return;}
 if(t.closest('[data-menu-open]')){event.preventDefault();p.querySelector('[data-source-menu]').hidden=false;return;}
 if(t.closest('.nav-bar-with-terms_oneTrustButton__DJnGb')){event.preventDefault();const link=p.querySelector('[data-source-menu] a[href*="/pages/data-sharing-opt-out"]');if(link)location.assign(link.href);return;}
 if(t.closest('[data-menu-close]')){event.preventDefault();p.querySelector('[data-source-menu]').hidden=true;return;}
 if(t.closest('[data-scratch-reveal]')){reveal();return;}
 const plan=t.closest('[data-offer-plan]');if(plan){selectedPlan=Number(plan.dataset.offerPlan);updatePlans();return;}
 if(t.closest('[data-offer-choose]')){event.preventDefault();p.querySelector('[data-offer-plan][aria-pressed="true"]')?.scrollIntoView({behavior:'smooth',block:'center'});return;}
 const faq=t.closest('[data-faq-toggle]')||t.closest('[class*="faqQuestion"]')?.querySelector('[data-faq-toggle]');if(faq){const expanded=faq.getAttribute('aria-expanded')!=='true',item=faq.closest('[data-test="faq__item"]');faq.setAttribute('aria-expanded',String(expanded));item.classList.toggle('faq-item_faqItemOpened__fTPGw',expanded);item.classList.toggle('faq-item_faqItem__bV4M6',!expanded);item.querySelector('[class*="faqAnswer"]').hidden=!expanded;return;}
 const more=t.closest('[data-read-more]');if(more){const card=more.closest('[class*="user-story-card_card"]')||more.parentElement;const expanded=card.dataset.expanded!=='true';card.dataset.expanded=String(expanded);more.textContent=expanded?'Read less':'Read more';}
});
app.addEventListener('keydown',e=>{if(['Enter',' '].includes(e.key)&&e.target.matches('[data-flow-option],[data-faq-toggle],[data-scratch-reveal]')){e.preventDefault();e.target.click();}if(e.key==='Escape'){const menu=panel().querySelector('[data-source-menu]');if(menu)menu.hidden=true;}});
app.addEventListener('input',()=>{error('');updateWeightNote();syncOptionalContinue();});
document.addEventListener('shopify:block:select',e=>{const p=e.target.closest('[data-flow-screen]');if(p)selectEditor(p.dataset.flowScreen);});
document.addEventListener('shopify:section:select',e=>{const p=e.target.querySelector('[data-flow-screen]');if(p)selectEditor(p.dataset.flowScreen);});
window.addEventListener('resize',expiredOfferLayout);

// Shopify replaces section nodes during a native setting edit. Refresh references
// before rendering, otherwise handlers keep reading detached panels.
document.addEventListener('shopify:section:load',e=>{
 if(!app.contains(e.target))return;
 for(const [root,dispose] of offerCarouselCleanups)if(!root.isConnected){dispose();offerCarouselCleanups.delete(root);}
 panels=[...app.querySelectorAll('[data-flow-screen]')];
 if(!panels.some(p=>p.dataset.flowScreen===(editorPanel||flow.current.id)))editorPanel=panels[0]?.dataset.flowScreen;
 if(panel())show();
});
// Shopify also evaluates previews containing only the edited section.
if(!panel()&&panels.length)editorPanel=panels[0].dataset.flowScreen;
restoreQuizJourneyFields({app,saved:restoredJourney});
if(panel())show();


/* Analytics only. Bundle the collector in this same hashed module BEFORE the
 * renderer, so the first event enters its durable queue without another fetch.
 * No copy, routing, input, image, payment or DOM mutations. */
function createPgQuizBridge({app,flow,definition,config},env=window){
 const noop={show(){},cta(){}};
 try{
  if(env.Shopify?.designMode||!app||app.__pgQuizBridge)return app?.__pgQuizBridge||noop;
  const sdk=env.NyQuiz;
  if(!sdk?.init||!sdk?.trackOnce)throw Error('Bundled quiz collector is missing');
  const screens=new Map(config.screens.map(s=>[s.key,s]));
  let lastScreen=null;
  Promise.resolve(sdk.init({quizKey:config.quizKey,versionKey:config.versionKey,
   endpoint:config.endpoint||'https://growth.nysonik.com',landingUrl:config.sourceUrl})).catch(()=>{});
  function send(type,data,once=false){try{return once?sdk.trackOnce(type,data):sdk.track(type,data);}catch{return null;}}
  function panel(id){return app.querySelector('[data-flow-screen="'+id+'"]');}
  function show(id){try{
   if(env.Shopify?.designMode||!screens.has(id)||lastScreen===id)return;
   send('quiz_start',{screenKey:id},true);
   const previous=lastScreen;lastScreen=id;
   send('screen_view',{screenKey:id,properties:previous?{previousScreenKey:previous}:{}});
   if(config.resultScreens.includes(id))send('result_view',{screenKey:id,resultKey:id});
   if(config.completeScreens.includes(id))send('quiz_complete',{screenKey:id},true);
  }catch{}}
  function answer(id,value){
   const s=screens.get(id);
   if(!s?.questionKey||s.type==='text')return; // Exclude names, emails, dates, country and arbitrary text.
   if(value===undefined||value===null||value===''||(Array.isArray(value)&&!value.length)){
    send('answer',{screenKey:id,questionKey:s.questionKey,answerValue:null,answerLabel:'Skipped'});return;
   }
   if(s.options){
    const values=Array.isArray(value)?value:[value],map=new Map(s.options.map(o=>[o.key,o.label]));
    if(values.some(v=>!map.has(v)))return;
    send('answer',{screenKey:id,questionKey:s.questionKey,answerValue:value,answerLabel:values.map(v=>map.get(v)).join('; ')});
   }else if(s.type==='number'&&typeof value==='number'&&Number.isFinite(value)){
    const unit=config.numberUnits?.[id];
    send('answer',{screenKey:id,questionKey:s.questionKey,answerValue:value,
     answerLabel:String(Math.round(value*100)/100)+(unit?' '+unit:''),
     properties:unit?{unit}: {}});
   }
  }
  const originalNext=flow.next.bind(flow),originalBack=flow.back.bind(flow);
  flow.next=function(value){const id=flow.current.id;const result=originalNext(value);if(result.ok&&!env.Shopify?.designMode){try{answer(id,value);}catch{}}return result;};
  flow.back=function(){const id=flow.current.id;const result=originalBack();if(result&&!env.Shopify?.designMode)send('back',{screenKey:id});return result;};
  function cta(action,clickedPlan){try{
   if(env.Shopify?.designMode||!lastScreen||!config.completeScreens.includes(lastScreen))return;
   if(!['offer_summary','scroll_to_plans','plan_select'].includes(action))return;
   const p=panel(lastScreen),card=clickedPlan||p?.querySelector('[data-offer-plan][aria-pressed="true"]');
   const raw=card?.getAttribute('data-offer-plan'),properties={action};
   if(/^[0-9]{1,2}$/.test(raw||''))properties.planIndex=Number(raw);
   // Only public plan-card copy, never other panel text or personal inputs.
   const label=card?.textContent?.replace(/\s+/g,' ').trim().slice(0,500);
   if(label)properties.planLabel=label;
   send(action==='offer_summary'?'cta_click':'offer_interaction',{screenKey:lastScreen,properties});
   Promise.resolve(sdk.flush()).catch(()=>{});
  }catch{}}
  const bridge={show,cta};app.__pgQuizBridge=bridge;
  app.addEventListener('click',event=>{try{
   const t=event.target;if(!t?.closest)return;
   const plan=t.closest('[data-offer-plan]');
   if(plan)cta('plan_select',plan);
   else if(t.closest('[data-offer-checkout]'))cta('offer_summary');
   else if(t.closest('[data-offer-choose],[data-offer-scroll]'))cta('scroll_to_plans');
  }catch{}});
  return bridge;
 }catch(error){
  try{env.dispatchEvent(new env.CustomEvent('nyquiz:health',{detail:{status:'blocked',reason:'pg_bridge_initialization_failed'}}));}catch{}
  return noop;
 }
}


/* Shared subscription handoff. No contact details or quiz answers leave
 * Quiz Lab. Only the visit, quiz and immutable version identify the purchase. */
const ANNUAL_OFFER = Object.freeze({
  endpoint: 'https://a56ba5-6f.myshopify.com/api/2026-10/graphql.json',
  variantId: 'gid://shopify/ProductVariant/67709186343157',
  sellingPlanId: 'gid://shopify/SellingPlan/10461085941',
  amount: 14.99,
  currency: 'USD',
});

const ANNUAL_CART_MUTATION = `mutation QuizAnnualCart($input: CartInput!) {
  cartCreate(input: $input) {
    cart {
      checkoutUrl attributes { key value }
      cost { totalAmount { amount currencyCode } }
      lines(first: 2) { nodes {
        quantity merchandise { ... on ProductVariant { id } }
        sellingPlanAllocation { sellingPlan { id name } }
      } }
    }
    userErrors { field message code }
  }
}`;

function annualCartInput({sessionId, quizKey, versionKey}) {
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(sessionId || '')) {
    throw new Error('Your quiz visit could not be saved. Please try again.');
  }
  if (!['pg-betterme-men', 'pg-justfit', 'pg-lasta', 'pg-yoga-go'].includes(quizKey)
    || !/^pg-[0-9a-f]{16}$/.test(versionKey || '')) {
    throw new Error('This quiz offer is not configured.');
  }
  return {
    lines: [{quantity: 1, merchandiseId: ANNUAL_OFFER.variantId, sellingPlanId: ANNUAL_OFFER.sellingPlanId}],
    attributes: [
      {key: '__nyq_session', value: sessionId},
      {key: '__nyq_quiz', value: quizKey},
      {key: '__nyq_version', value: versionKey},
    ],
  };
}

function verifiedAnnualCheckout(response, input) {
  const result = response?.data?.cartCreate;
  if (response?.errors?.length || result?.userErrors?.length || !result?.cart) {
    throw new Error('Checkout is unavailable. Please try again.');
  }
  const cart = result.cart, lines = cart.lines?.nodes || [];
  if (lines.length !== 1 || lines[0].quantity !== 1
    || lines[0].merchandise?.id !== ANNUAL_OFFER.variantId
    || lines[0].sellingPlanAllocation?.sellingPlan?.id !== ANNUAL_OFFER.sellingPlanId
    || Number(cart.cost?.totalAmount?.amount) !== ANNUAL_OFFER.amount
    || cart.cost?.totalAmount?.currencyCode !== ANNUAL_OFFER.currency) {
    throw new Error('The checkout price or subscription has changed. Please try again later.');
  }
  const attributes = new Map((cart.attributes || []).map(a => [a.key, a.value]));
  if (input.attributes.some(a => attributes.get(a.key) !== a.value)) {
    throw new Error('Your quiz could not be linked to checkout. Please try again.');
  }
  let url;
  try { url = new URL(cart.checkoutUrl); } catch { throw new Error('Checkout is unavailable. Please try again.'); }
  if (url.protocol !== 'https:' || url.hostname !== 'pilatesflo.com'
    || url.username || url.password || url.port
    || !(/^\/cart\/c\//.test(url.pathname) || /^\/checkouts\//.test(url.pathname))) {
    throw new Error('Checkout is unavailable. Please try again.');
  }
  return url.href;
}

function createAnnualCheckout({sdk, quizKey, versionKey, fetchImpl = fetch, navigate = url => window.location.assign(pgTrybeCheckoutUrl(url, window.location.search))}) {
  let pending = null;
  let prepared = null;
  async function saveEvents() {
    const deadline = Date.now() + 8000;
    do {
      let timer;
      try {
        await Promise.race([
          sdk.flush(),
          new Promise((_, reject) => { timer = setTimeout(() => reject(new Error('Your quiz could not be saved. Please try again.')), Math.max(1, deadline - Date.now())); }),
        ]);
      } finally { clearTimeout(timer); }
      const health = sdk.getHealth?.();
      if (!health || (health.status !== 'blocked' && health.pending === 0)) return;
      if (health.status === 'blocked') break;
      await new Promise(resolve => setTimeout(resolve, 100));
    } while (Date.now() < deadline);
    throw new Error('Your quiz could not be saved. Please try again.');
  }
  return function checkout(screenKey) {
    if (pending) return pending;
    pending = (async () => {
      // Bootstrap/flush first so a new or resumed visit has its real identifier.
      await saveEvents();
      const input = annualCartInput({sessionId: sdk.getSessionId(), quizKey, versionKey});
      const identity = JSON.stringify(input.attributes);
      if (prepared?.identity === identity) {
        await saveEvents();
        navigate(prepared.url);
        return true;
      }
      const response = await fetchImpl(ANNUAL_OFFER.endpoint, {
        method: 'POST', credentials: 'omit',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({query: ANNUAL_CART_MUTATION, variables: {input}}),
        signal: AbortSignal.timeout(15000),
      });
      // Never automatically retry a cart creation whose response was lost.
      if (!response.ok) throw new Error('Checkout is unavailable. Please try again.');
      const url = verifiedAnnualCheckout(await response.json(), input);
      prepared = {identity, url};
      sdk.track('cta_click', {screenKey, properties: {
        action: 'checkout_started', planLabel: 'Flo subscription',
        amount: 14.99, currency: 'USD', billingPeriod: '28_days',
      }});
      await saveEvents();
      navigate(url);
      return true;
    })().finally(() => { pending = null; });
    return pending;
  };
}

/* Binds the real annual cart to the existing offer controls. */
function bindAnnualCheckout({app, sdk, quizKey, versionKey, checkoutFactory, saveJourney = () => {}, designMode = false}) {
  if (designMode || app.__annualCheckoutBound) return;
  app.__annualCheckoutBound = true;
  const checkout = checkoutFactory({sdk, quizKey, versionKey});
  let busy = false;
  app.addEventListener('click', async event => {
    const target = event.target?.closest?.('[data-annual-checkout]');
    if (!target || !app.contains(target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    const panel = target.closest('[data-flow-screen]');
    if (!panel || panel.hidden) return;
    let status = panel.querySelector('[data-annual-checkout-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.annualCheckoutStatus = '';
      status.setAttribute('role', 'status');
      status.style.cssText = 'font:inherit;padding:12px;text-align:center;';
      target.insertAdjacentElement('afterend', status);
    }
    const consent = panel.querySelector('[data-offer-consent]');
    if (consent && consent.getAttribute('aria-checked') !== 'true') {
      status.textContent = 'Review the terms and select the agreement checkbox to continue.';
      consent.scrollIntoView({block: 'center', behavior: 'smooth'});
      consent.focus();
      return;
    }
    busy = true;
    const controls = [...app.querySelectorAll('[data-annual-checkout]')];
    controls.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    status.textContent = 'Opening your $14.99 first 28-day Flo subscription checkout…';
    try {
      saveJourney(panel.dataset.flowScreen);
      await checkout(panel.dataset.flowScreen);
    } catch (error) {
      status.textContent = error instanceof Error ? error.message : 'Checkout is unavailable. Please try again.';
    } finally {
      busy = false;
      controls.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
    }
  }, true);
}

/* Same-tab progress and checkout return. No answer or contact data leaves the browser. */
// These helpers are hoisted: compiled renderers restore before this source's
// position in the bundle is evaluated.
function journeyFields(schema = 4) {
  const retired = schema < 4 ? ',[data-retired-precheck]' : '';
  const legacy = 'input,select,textarea,[data-flow-unit],[data-offer-consent]' + retired;
  const selections = 'input,select,textarea,[data-flow-option],[data-flow-choice],[data-flow-unit],[data-offer-consent],[data-multi-footer]' + retired;
  return schema < 2 ? legacy : schema === 2 ? selections : selections + ',[data-flow-next]';
}
function journeyDecorations(app) {
  return [...app.querySelectorAll('[data-flow-screen]')].flatMap(panel => {
    const labels = [...panel.querySelectorAll('[data-unit-label],[data-range-min],[data-range-max],[data-date-value],.input-description,[class*="postfix"]')];
    const hidden = [...panel.querySelectorAll('[data-inches-wrap],.height-heightInches,[data-body-zone]')];
    const units = [...panel.querySelectorAll('[data-flow-unit]')];
    const fields = [...panel.querySelectorAll('[data-flow-input]')];
    // Calisthenics uses an unmarked wrapper for the inches input; Fitness uses
    // a decorative pill behind its unit buttons. Only these unit controls apply.
    if (units.length && fields.length > 1 && fields[1].parentElement) hidden.push(fields[1].parentElement);
    for (const unit of units) {
      const indicator = unit.parentElement?.querySelector('.absolute');
      if (indicator) hidden.push(indicator);
    }
    return [{panel, labels, hidden:[...new Set(hidden)]}];
  });
}
function restoreQuizJourneyFields({app, saved}) {
  if (!saved) return;
  const fields = [...app.querySelectorAll(journeyFields(saved.schema || 1))];
  for (const item of saved.fields || []) {
    const field = fields[item.index]; if (!field || field.matches?.('[data-retired-precheck]')) continue;
    if (typeof item.value === 'string' && 'value' in field) field.value = item.value;
    if (typeof item.checked === 'boolean' && 'checked' in field) field.checked = item.checked;
    if (item.ariaChecked === 'true' || item.ariaChecked === 'false') field.setAttribute('aria-checked', item.ariaChecked);
    if (item.ariaSelected === 'true' || item.ariaSelected === 'false') field.setAttribute('aria-selected', item.ariaSelected);
    if (item.pressed === 'true' || item.pressed === 'false') field.setAttribute('aria-pressed', item.pressed);
    if (typeof item.hidden === 'boolean' && field.matches?.('[data-multi-footer]')) field.hidden = item.hidden;
    if (typeof item.disabled === 'boolean' && field.matches?.('[data-flow-next]')) field.disabled = item.disabled;
    for (const attribute of ['placeholder','maxlength','aria-label']) {
      if (typeof item.attributes?.[attribute] === 'string') field.setAttribute(attribute, item.attributes[attribute]);
      else if (item.attributes?.[attribute] === null) field.removeAttribute(attribute);
    }
  }
  const panels = [...app.querySelectorAll('[data-flow-screen]')];
  for (const item of saved.units || []) {
    const panel = panels.find(p => p.dataset.flowScreen === item.screen);
    if (panel && ['metric','imperial'].includes(item.unit)) panel.dataset.unit = item.unit;
  }
  for (const {panel,labels,hidden} of journeyDecorations(app)) {
    const state = saved.decorations?.find(item => item.screen === panel.dataset.flowScreen);
    if (!state) continue;
    for (const [index, item] of (state.labels || []).entries()) {
      const label = labels[index]; if (!label) continue;
      if (typeof item.text === 'string') label.textContent = item.text;
      if (typeof item.original === 'string') label.dataset.original = item.original;
    }
    for (const [index, value] of (state.hidden || []).entries()) if (hidden[index] && typeof value === 'boolean') hidden[index].hidden = value;
  }
}
function replayAnnualJourney(flow, definition, saved) {
  if (!saved || !Array.isArray(saved.visited) || saved.visited.length > definition.screens.length || saved.visited[0] !== definition.start) return false;
  const trial = new flow.constructor(definition);
  for (let i = 0; i < saved.visited.length - 1; i++) {
    if (trial.current.id !== saved.visited[i]) return false;
    const result = trial.next(saved.answers?.[trial.current.id]);
    if (!result.ok || trial.current.id !== saved.visited[i + 1]) return false;
  }
  if (trial.current.id !== saved.flowScreen) return false;
  for (let i = 0; i < saved.visited.length - 1; i++) flow.next(saved.answers?.[flow.current.id]);
  return true;
}

async function restoreAnnualJourney({app, flow, definition, config, sdk, restoreFields = true, storage = window.sessionStorage}) {
  if (window.Shopify?.designMode) return null;
  const key = 'pg:annual-return:' + config.quizKey + ':' + config.versionKey;
  try {
    const raw = storage.getItem(key);
    if (!raw || raw.length > 100000) return null;
    const saved = JSON.parse(raw);
    const validScreen = definition.screens.some(screen => screen.id === saved.flowScreen)
      && (saved.screen === saved.flowScreen || (config.completeScreens.includes(saved.screen) && definition.screens.find(screen => screen.id === saved.flowScreen)?.terminal));
    if (!Number.isFinite(saved.savedAt) || Date.now() - saved.savedAt > 30 * 60 * 1000 || saved.savedAt > Date.now() || !validScreen) { storage.removeItem(key); return null; }
    await sdk.init({quizKey:config.quizKey,versionKey:config.versionKey,endpoint:config.endpoint||'https://growth.nysonik.com',landingUrl:config.sourceUrl});
    if (!saved.sessionId || sdk.getSessionId() !== saved.sessionId || !replayAnnualJourney(flow, definition, saved)) { storage.removeItem(key); return null; }
    if (restoreFields) restoreQuizJourneyFields({app, saved});
    app.dataset.annualReturnScreen = saved.screen;
    return saved;
  } catch { return null; }
}

function saveAnnualJourney({app, flow, sdk, quizKey, versionKey, screen, storage = window.sessionStorage}) {
  if (!sdk.getSessionId() || !flow.current.terminal) throw new Error('Your completed plan could not be saved. Please try again.');
  saveQuizJourney({app, flow, sdk, quizKey, versionKey, screen, storage});
}

function saveQuizJourney({app, flow, sdk, quizKey, versionKey, screen = flow.current.id, storage = window.sessionStorage}) {
  const sessionId = sdk.getSessionId();
  if (!sessionId) return false;
  const saved = {
    schema:4, savedAt:Date.now(), sessionId, screen, flowScreen:flow.current.id, visited:flow.visited, answers:flow.answers,
    fields:[...app.querySelectorAll(journeyFields())].map((f,index)=>({index,value:'value' in f?f.value:undefined,checked:'checked' in f?f.checked:undefined,pressed:f.getAttribute('aria-pressed'),ariaChecked:f.getAttribute('aria-checked'),ariaSelected:f.getAttribute('aria-selected'),hidden:f.matches?.('[data-multi-footer]')?f.hidden:undefined,disabled:f.matches?.('[data-flow-next]')?f.disabled:undefined,attributes:Object.fromEntries(['placeholder','maxlength','aria-label'].map(name=>[name,f.getAttribute(name)]))})),
    units:[...app.querySelectorAll('[data-flow-screen][data-unit]')].map(p=>({screen:p.dataset.flowScreen,unit:p.dataset.unit})),
    decorations:journeyDecorations(app).map(({panel,labels,hidden})=>({screen:panel.dataset.flowScreen,labels:labels.map(label=>({text:label.textContent,original:label.dataset.original})),hidden:hidden.map(node=>node.hidden)})),
  };
  try { storage.setItem('pg:annual-return:' + quizKey + ':' + versionKey, JSON.stringify(saved)); }
  catch { throw new Error('Allow session storage so your completed plan can be restored after checkout.'); }
  return true;
}

/** Bind after the renderer. Restore before constructing the analytics bridge,
 * so replaying saved transitions never emits answer events. */
function bindQuizJourney({app, flow, sdk, config, bridge, env = window}) {
  if (env.Shopify?.designMode || app.__pgJourneyBound) return;
  app.__pgJourneyBound = true;
  const persist = () => {
    try {
      saveQuizJourney({app, flow, sdk, ...config, screen:app.dataset.currentScreen || flow.current.id, storage:env.sessionStorage});
    } catch {
      env.dispatchEvent(new env.CustomEvent('nyquiz:health', {detail:{status:'degraded',reason:'quiz_progress_storage_unavailable'}}));
    }
  };
  const show = bridge.show.bind(bridge);
  bridge.show = id => { show(id); persist(); };
  for (const event of ['input','change','click']) app.addEventListener(event, () => env.queueMicrotask(persist));
  // Initialization may finish after the first interaction. Save the latest
  // state when the collector has established this tab's visit ownership.
  Promise.resolve(sdk.init({quizKey:config.quizKey,versionKey:config.versionKey,endpoint:config.endpoint||'https://growth.nysonik.com',landingUrl:config.sourceUrl})).then(persist).catch(() => {});
}
// Keep the source result slots, but populate them from the recorded answers.
function menAnswerProfile(answers) {
  return {
    pushups:({o1:"Can't do push-ups yet",o2:'1-10 push-ups',o3:'11-20 push-ups',o4:'20+ push-ups'})[answers.s12] || 'Not answered',
    goal:({o1:'Gain muscle',o2:'Lose weight',o3:'Lose fat and gain muscle',o4:'Improve overall fitness'})[answers.s04] || 'Not answered',
    experience:answers.s02==='o1'?'Some experience':answers.s02==='o2'?'Beginner':'Not answered',
    direction:answers.s02==='o1'?'Keep progressing':'Build consistency',
  };
}

function syncMenAnswerProfile(panel, answers) {
  if (panel.dataset.flowScreen !== 's53') return;
  const profile = menAnswerProfile(answers);
  for (const [side,titles,values] of [
    ['current',['Push-up range','Pilates experience'],[profile.pushups,profile.experience]],
    ['goal',['Training goal','Practice direction'],[profile.goal,profile.direction]],
  ]) {
    panel.querySelectorAll('[data-test="conditionalInfo__titleValue titleValue--block_'+side+'"]').forEach((el,i)=>{el.textContent=titles[i];});
    panel.querySelectorAll('[data-test="conditionalInfo__infoValue infoValue--block_'+side+'"]').forEach((el,i)=>{el.textContent=values[i];});
  }
}

function yogaAnswerProfile(answers) {
  const bmi = answers.s22 && answers.s23 ? answers.s23/(answers.s22/100)**2 : null;
  return {
    body:({o0_slim:'Slim',o1_lean:'Lean',o2_extra:'A little extra',o3_extra:'Overweight',o4_extra:'Obese'})[answers.s06] || 'Not answered',
    shape:({o0_slim:'Slim',o1_lean:'Lean',o2_fit:'Fit',o3_athletic:'Athletic',o4_curvy:'Curvy'})[answers.s07] || 'Not answered',
    experience:({o0_beginner:'Beginner',o1_beginner:'Experienced beginner',o2_intermediate:'Intermediate',o3_advanced:'Advanced'})[answers.s14] || 'Not answered',
    direction:answers.s14==='o0_beginner'?'Build consistency':'Keep progressing',
    bmiLabel:bmi ? (bmi<18.5?'Underweight':bmi<25?'Normal':bmi<30?'Overweight':'Obese')+' - '+bmi.toFixed(1) : null,
  };
}

function syncYogaAnswerProfile(panel, answers) {
  const profile = yogaAnswerProfile(answers);
  if (panel.dataset.flowScreen === 's27' && profile.bmiLabel) {
    const label = panel.querySelector('[data-pg-bmi-summary]') || [...panel.querySelectorAll('p')].find(el=>el.textContent.trim()==='Normal - 21.5');
    if (label) { label.dataset.pgBmiSummary=''; label.textContent=profile.bmiLabel; }
  }
  if (panel.dataset.flowScreen !== 's35') return;
  for (const [side,shape,experience] of [['before',profile.body,profile.experience],['after',profile.shape,profile.direction]]) {
    const text = panel.querySelector('[data-locator="'+side+'PersonalData1"]');
    const fields = {
      [side+'PersonalDataTitle1']:'Body shape', [side+'PersonalData1']:shape,
      [side+'PersonalDataTitle2']:side==='before'?'Pilates experience':'Practice direction', [side+'PersonalData2']:experience,
    };
    for (const [locator,value] of Object.entries(fields)) {
      const el=panel.querySelector('[data-locator="'+locator+'"]');
      if (!el) continue;
      el.textContent=value;
      if (locator.endsWith('PersonalData2') && text) { el.className=text.className; el.removeAttribute('data-value'); }
    }
  }
}

bindAnnualCheckout({app,sdk:window.NyQuiz,quizKey:"pg-betterme-men",versionKey:"pg-73a023c12b3408e5",checkoutFactory:createAnnualCheckout,saveJourney:screen=>saveAnnualJourney({app,flow,sdk:window.NyQuiz,quizKey:"pg-betterme-men",versionKey:"pg-73a023c12b3408e5",screen}),designMode:!!window.Shopify?.designMode});

bindQuizJourney({app,flow,sdk:window.NyQuiz,config:annualResumeConfig,bridge:pgAnalytics});
